import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)
/**
 * Get payments coupon progress info
 * @param {String} pdn
 */
export const getPaymentsCouponProgress = (
  pdn, authToken, sfid
) => {

  if(pdn?.length > 0){
    return req.get('/payments/coupon/progress', {
      headers: {
        Authorization: authToken
      },
      params: {
        pdn
      }
    })
  }else {
    return req.get(`/payments/promotions?donorSfid=${sfid}`, {
      headers: {
        Authorization: authToken
      }
    })
  }
  
}

/**
 * Apply payment promoCode
 * @param {String} promoCode
 * @param {String} token
 */
export const applyPaymentPromoCode = (
  promoCode,
  overrideOthers,
  token
) => {

  const config = {
    headers: {
      Authorization: token
    }
  }
  return req.post('/payments/promocode/apply', { promoCode, overrideOthers }, config)
}

/**
 * Get payment history
 * @param {String} pdn
 */
export const getPaymentHistory = (
  pdn,startDate,
  endDate, authToken
) => {
  return req.get('/payments/history', {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn,startDate,
      endDate,
    }
  })
}
